import { Button, FormControl, MenuItem, Paper, Select } from "@mui/material";
import { useMutation } from "@apollo/client";
import { makeStyles } from "@mui/styles";
import { Box, Container } from "@mui/system";
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { gql } from "@apollo/client";

const useStyles = makeStyles({
  root: {
    width: "100%",
    display: "flex",
    alignItems: "center",
  },
  h2: {
    lineHeight: 1,
  },
  thank: {
    textAlign: "center",
    width: "100%",
    position: "fixed",
    top: "40%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
  buttonClass: {
    borderRadius: "0px important!",
  },
});

const ThankYou = (_) => {
  const classes = useStyles();
  let { id } = useParams();
  const [channel, setChannel] = useState("Email");
  const [isSub, setIsSub] = useState(false);

  const onChangeSub = (evt) => {
    setChannel(evt.target.value);
  };

  const SET_SUBSCRIPTION = gql`
    mutation setSubscription($id: String, $channel: String) {
      setSubscription(id: $id, channel: $channel)
    }
  `;

  const [doSetSubscription] = useMutation(SET_SUBSCRIPTION);
  const doSubscribe = async () => {
    const { loading } = await doSetSubscription({
      variables: {
        id,
        channel,
      },
    });

    if (!loading) {
      setIsSub(true);
    }
  };

  return (
    <div className={classes.thank}>
      <Container maxWidth="md" style={{ textAlign: "center" }}>
        <h2 className={classes.h2}>Survey Completed. </h2>
        <h2 className={classes.h2}>Thank you!</h2>
        <Box textAlign="left">
          <p>
            We appreciate you taking the time to complete our Call &amp; Collect
            Survey!
          </p>
          <p>- ACE Hardware Team</p>
        </Box>
        <br />
        <br />
        <br />
        {!isSub && (
          <Box>
            <Paper variant="outlined" square elevation={1}>
              <Box m={2}>
                <h3 className={classes.h2}>Stay in Touch</h3>
                <Box textAlign="left">
                  <p>
                    I would like to receive information about ongoing Ace
                    Hardware promotions through
                  </p>
                  <Box display="flex" justifyContent="center">
                    <FormControl fullWidth variant="outlined" color="primary">
                      <Select
                        style={{ borderRadius: 0 }}
                        value={channel}
                        onChange={onChangeSub}
                      >
                        <MenuItem value="SMS">SMS</MenuItem>
                        <MenuItem value="Email">Email</MenuItem>
                        <MenuItem value="Viber">Viber</MenuItem>
                        <MenuItem value="Facebook">Facebook</MenuItem>
                      </Select>
                    </FormControl>
                    <Button
                      variant="contained"
                      color="primary"
                      className={classes.buttonClass}
                      style={{ borderRadius: 0 }}
                      onClick={() => doSubscribe()}
                    >
                      Subscribe
                    </Button>
                  </Box>
                </Box>
              </Box>
            </Paper>
          </Box>
        )}

        {isSub && (
          <Box>
            <Paper
              variant="outlined"
              square
              elevation={1}
              style={{ backgroundColor: "#ff0000", color: "#fff" }}
            >
              <Box m={2}>
                <h3>Thanks for subscribing via {channel}!</h3>
              </Box>
            </Paper>
            <p>To go ACE Call &amp; Collect, click the button below.</p>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                window.location.href = "https://call-collect.acehardware.ph/";
                return null;
              }}
            >
              Call &amp; Collect
            </Button>
          </Box>
        )}
      </Container>
    </div>
  );
};

export default ThankYou;
